import React from "react";
const getFillColor = (color: string) => {
  return color === "currentColor" ? `` : `var(--color-${color})`;
};
const SvgInfoIcon = ({ title, theme = null, titleId = "", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    width="1em"
    height="1em"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M32 2a30 30 0 1 0 30 30A30.034 30.034 0 0 0 32 2Zm4.576 47.367A18.587 18.587 0 0 1 30.613 51a3.942 3.942 0 0 1-2.969-1.028 4.036 4.036 0 0 1-.891-3.727c.347-2.184 2.671-10.488 3.318-13.944.177-.942.4-2.851-.271-3.529-.856-.857-3.515-.294-4.68.012l.371-1.583a17.893 17.893 0 0 1 5.886-1.707 3.9 3.9 0 0 1 2.943.966 4.385 4.385 0 0 1 .816 3.814c-.128.992-.035.486-2.926 12.061-.4 1.589-1.146 4.39.015 5.35 1.144.947 4.045.35 4.721.1ZM35 19a3 3 0 1 1 3-3 3 3 0 0 1-3 3Z"
      className="info_svg__nc-icon-wrapper"
    />
  </svg>
);
export interface Props {
  color?: string;
  width?: string;
  height?: string;
  title: string;
  titleId?: string;
  theme?: any;
  fill?: string;
}
const SvgInfoStyle = ({
  color = "currentColor",
  title,
  fill,
  ...props
}: Props) => (
  <SvgInfoIcon
    color={getFillColor(color)}
    className={color === "currentColor" ? "icon-current-color" : ""}
    {...(color !== "currentColor"
      ? { style: { color: getFillColor(color), fill: getFillColor(color) } }
      : null)}
    fill={fill ?? getFillColor(color)}
    title={title}
    {...props}
  />
);
export const InfoIcon: any = SvgInfoStyle;
export default InfoIcon;
